import { useSliderState } from "./Slider";

export const SliderState = ({ children }) => {
  const state = useSliderState();
  return children(state);
};

export default SliderState;
